<template>
	<div class="hotel">
		<div class="hotelInfo">
			<h4>酒店预订说明</h4>
			<p>{{matchInfo.hotelInfo}}</p>
		</div>
		<div class="hotelTable">
		  <el-table
		    :data="tableData"
		    border
		    style="width: 100%"
		    :span-method="objectSpanMethod">
		    <el-table-column
		      label="酒店"
		      width="180"
		      align="center">
		      <template slot-scope="scope">
		      	<a :href="scope.row.hotelUrl" target="_blank">
		      		<span>{{scope.row.hotelName}}</span>
		      		<img :src="(scope.row.hotelImg==''|| scope.row.hotelImg == null)? headimg : scope.row.hotelImg" class="head-img" alt="暂无图片"  style="width:100%"/>

		      	</a>
		      	</template>
		    </el-table-column>
		    <el-table-column
		      align="center"
		      prop="roomName"
		      label="房型"
		      width="120">
		    </el-table-column>
		    <el-table-column
		      prop="roomInfo"
		      align="center"
		      label="说明">
		    </el-table-column>
		    <el-table-column
		      prop="sportCount"
		      align="center"
		      label="运动员数量"
		      width="120">
		    </el-table-column>
		    <el-table-column
		      prop="ortherCount"
		      align="center"
		      label="其他人员数量"
		      width="120">
		    </el-table-column>
		 	<el-table-column
		 		label="操作"
		 		align="center"
		 		width="250">
		      <template slot-scope="scope">
		        <el-button
		          type="primary"
		          size="mini"
		          @click="handleOrder(scope.$index, scope.row)"
		          round
		          class="bb"
		          style="font-size:12px">运动员预订</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="handleOrderInfo(scope.$index, scope.row)"
              round
              class="bb"
              style="font-size:12px">其他人员预订</el-button>
		      </template>
		    </el-table-column>
		  </el-table>

		  <el-dialog title="运动员预订" :visible.sync="dialogFormVisible">
        <div style="display: flex;justify-content: space-between">
          <el-form :inline="true" :model="athletesForm" class="demo-form-inline">
            <el-form-item style="width:240px; margin: 0;">
              <el-radio-group v-model="athletesForm.memberSex" @change="athletesQueryList">
                <el-radio label="">全部</el-radio>
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <span style="margin-right: 10px;vertical-align: bottom">选中{{athletesSelectList.length}}人</span>
        </div>

        <el-table
          :data="athletesList"
          border
          resizable="false"
          style="width: 100%"
          ref="athletesTable"
          @selection-change="athletesChange">
          <el-table-column
            type="selection"
            width="55"
            align="center">
          </el-table-column>
          <el-table-column
            label="姓名"
            align="center"
            prop="memberName">
          </el-table-column>
          <el-table-column
            label="性别"
            width="60"
            align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{scope.row.memberSex | sexToData}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="memberIdCard"
            label="证件号码"
            width="180"
            align="center">
          </el-table-column>
          <el-table-column
            label="出生日期"
            width="120"
            align="center">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{scope.row.memberBith | timestampToDate}}</span>
            </template>

          </el-table-column>
        </el-table>
			  <div slot="footer" class="dialog-footer" style="text-align: center;">
			    <el-button @click="athletesCancel" round style="border:1px solid #44c1de;color:#44c1de">取 消</el-button>
			    <el-button type="primary" @click="athletesSure" round class="bb">确 定</el-button>
			  </div>
			</el-dialog>


      <el-dialog title="其他人员预订" :visible.sync="dialogPersonListShow">
        <div style="display: flex;justify-content: space-between">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item style="margin: 0;" label="性别：">
              <el-radio-group v-model="formInline.serviceSex" @change="personQueryList">
                <el-radio label="">全部</el-radio>
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <br>
            <el-form-item style="margin: 0;" label="类别：">
              <el-radio-group v-model="formInline.serviceType" @change="personQueryList">
                <el-radio label="">全部</el-radio>
                <el-radio :label="1">家长</el-radio>
                <el-radio :label="2">教练</el-radio>
                <el-radio :label="3">领队</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <span style="margin-right: 10px">选中{{personSelectList.length}}人</span>
        </div>


            <el-table
              :data="personList"
              border
              resizable="false"
              style="width: 100%"
              ref="personTable"
              @selection-change="handleSelectionChange">
              <el-table-column
                type="selection"
                width="55"
                align="center">
              </el-table-column>
              <el-table-column
                label="姓名"
                align="center"
              prop="serviceName">
              </el-table-column>
              <el-table-column
                label="性别"
                width="60"
                align="center">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{scope.row.serviceSex | sexToData}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="serviceCertNumber"
                label="证件号码"
                width="180"
                align="center">
              </el-table-column>
              <el-table-column
                label="手机号码"
                width="120"
                align="center"
                prop="serviceMobile">
              </el-table-column>

              <el-table-column
                label="类别"
                width="80"
                align="center">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{scope.row.serviceType | serviceTypeTodata}}</span>
                </template>
              </el-table-column>
            </el-table>




        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogPersonListShow = false">取 消</el-button>
          <el-button type="primary" @click="personSure">确 定</el-button>
        </div>

      </el-dialog>
		</div>
    <div style="display: none">{{changeMatchMsg}}</div>
  </div>
</template>

<script>
	import axios from 'axios'
	export default {
    data() {
      return {
      	userInfos:JSON.parse(localStorage.getItem("userInfos")),
      	matchInfo:JSON.parse(sessionStorage.getItem('matchInfo')),
        tableData: [],
        hotelList:[],
        dialogFormVisible:false,
        orderForm:{},
        formLabelWidth:'120px',
        matchCode:'',
        athletesList:[],
        athletesInfo:[],
        athletesSelectList:[],
        personList:[],
        personInfo:[],
        personSelectList:[],
        dialogPersonListShow:false,
        formInline:{
          serviceSex:"",
          serviceType:""
        },
        athletesForm: {
          "memberName":"",//姓名 模糊匹配 选填
          "memberSex":"",//性别 0-男 1-女  全部的时候，不传此参数
          "memberLevel":"",//运动员等级 0-大众 1-专业 全部的时候，不传此参数
          "memberWeapon":"",//剑种 1-花剑 2-重剑 3-配剑全部的时候，不传此参数
          "bithStartDate":"",//出生日期开始
          "bithEndDate":"",//出身日期结束
          "pageSize":10000
        },
        activeName:'first',

      };
    },
    computed: {
      changeMatchMsg(){
        this.matchCode = this.$store.state.matchCodeMsg;
        this.onSubmit();
        return this.$store.state.matchCodeMsg
      }
    },
    mounted(){
      this.matchInfoList()
    		this.onSubmit()
      this.personQueryList()
      this.athletesQueryList()
    },
    filters: {
      timestampToDate(data) {
        return global.timestampToDate(data);
      },
      levelTodata(val){
        return val==0 ? '大众':'专业'
      },
      WeaponToData(val){
        if(val==1){
          return val='花剑'
        }else if(val==2){
          return val='重剑'
        }else if(val==3){
          return val='佩剑'
        }
      },
      sexToData(val){
        return val==0 ? '男':'女'
      },
      memberWayToData(val){
        if(val==0){
          return val='未知'
        }else if(val==1){
          return val='左手'
        }else if(val==2){
          return val='右手'
        }
      },
      serviceTypeTodata(val){
        if(val==1){
          return val='家长'
        }else if(val==2){
          return val='教练'
        }else if(val==3){
          return val='领队'
        }
      }
    },
    methods: {
      matchInfoList(){
        for(let i=0;i<this.matchInfo.length;i++){
          if(this.matchInfo[i].matchCode==this.matchCode){
            this.matchInfo=this.matchInfo[i]
          }
        }
      },
    		onSubmit(){
	    		var self=this
	    		var postData={
	    			matchCode:this.matchCode,
	    			clubCode:this.userInfos.clubCode
	    		}
	    		axios.post('/marlin/sign/data/hotel/info/query/list',postData)
	    		.then(function(res){
	    			if(res.data.code==0){
					//处理房型
	    				var list=[]
	    				for(var i=0;i<res.data.rst.length;i++){
	    					var hotelName =res.data.rst[i].hotelName
	    					var hotelImg =res.data.rst[i].hotelImg
	    					var hotelUrl =res.data.rst[i].hotelUrl
	    					var roomSize=res.data.rst[i].roomList.length
	    					for(var j=0;j<res.data.rst[i].roomList.length;j++){
							res.data.rst[i].roomList[j].hotelName=hotelName;
							res.data.rst[i].roomList[j].hotelUrl=hotelUrl;
							res.data.rst[i].roomList[j].hotelImg=hotelImg;
							if(j==0){
								res.data.rst[i].roomList[j].roomSize=roomSize;
							}else{
								res.data.rst[i].roomList[j].roomSize=0
							}
							list.push(res.data.rst[i].roomList[j])
	    					}
	    				}
	    				self.tableData=list
	    			}else{

	    			}
	    		})
	    		.catch(function(res){
	    			overdue(res.response,res.response.status,self)
	    		})
    		},
      athletesQueryList(){
        let self=this
        axios.post('/marlin/sign/data/club/member/query/list',this.athletesForm)
          .then(function(res){
            if(res.data.code==0){
              self.athletesList=res.data.rst
              console.log(self.athletesList)
            }else{
              self.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          })
          .catch(function(err){
            overdue(err.response,err.response.status,self)
          })
      },
      personQueryList() {
        let self=this
        let postData={
          "clubCode":this.userInfos.clubCode,//俱乐部编码 必填
          "serviceCode":"",//服务人员编码 选填
          "serviceType":this.formInline.serviceType,//服务人员类型 0-家长 1-教练 2-领队 选填
          "serviceSex":this.formInline.serviceSex,//服务人员性别 0-男 1-女 选填
          "serviceName":"",//服务人员姓名 选填
          "pageSize":15,//每页数量 必填
          "pageIndex":1//页码 必填

        }

          axios.post('/marlin/sign/club/service/query/list',postData)
          .then(function(res){
            if(res.data.code==0){
              self.personList=res.data.rst

              console.log(res)

            }else{
              self.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          })
          .catch(function(err){
            overdue(err.response,err.response.status,self)
          })
      },
      handleSelectionChange(val) {
        console.log(val)
        this.personSelectList=val
      },
      athletesChange(val){
    		  console.log(val)
        this.athletesSelectList=val

      },
    handleOrder(index,row){
      let  self=this
      this.athletesInfo=row
      this.dialogFormVisible=true
      let postData={
        roomCode:row.roomCode,
        clubCode:this.userInfos.clubCode,
        matchCode:this.$route.query.matchCode,
        peopleType:0
      }
      console.log(postData)
      axios.post('/marlin/sign/data/sign/hotel/query/list',postData)
        .then(function (res) {
          console.log('res',res)
          let athList=[]
          for(let j=0;j<self.athletesList.length;j++){
            for(let i=0;i<res.data.rst.length;i++){
              if(res.data.rst[i].peopleCode==self.athletesList[j].memberCode){
                athList.push(self.athletesList[j])
              }
            }
          }
          self.toggleSelection(athList)
        })
        .catch(function (res) {

        })
    },
    toggleSelection(rows) {
      this.$refs.athletesTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.athletesTable.toggleRowSelection(row,true);
        });
      }
    },
    persontoggleSelection(rows) {
      this.$refs.personTable.clearSelection();
      if (rows) {
        rows.forEach(row => {
          this.$refs.personTable.toggleRowSelection(row,true);
        });
      }
    },
    athletesCancel(){
      this.dialogFormVisible=false
    },
    athletesSure(){
        console.log('选中运动员',this.athletesSelectList)
      let self=this
      if(null!=this.athletesSelectList && this.athletesSelectList.length>0){
          let postData={
            "matchCode":this.$route.query.matchCode,
            "roomCode":this.athletesInfo.roomCode,
            "clubCode":this.userInfos.clubCode,
            "peopleType":0,//0-运动员 1-非运动员
            peopleList:[]
          }
        for(let i=0;i<this.athletesSelectList.length;i++){
            postData.peopleList.push(
              {
              "peopleCode":this.athletesSelectList[i].memberCode,
              "peopleType":0, //0-运动员 1-家长 2-教练 3-领队
              "peopleSex":this.athletesSelectList[i].memberSex
              }
            )

            }
        console.log('postDatapostData',postData)
        axios.post('/marlin/sign/data/sign/hotel/add',postData)
          .then(function (res) {
            console.log(res)
            self.$message({
              message:res.data.msg,
              type:'success'
            })
            self.dialogFormVisible=false
          })
          .catch(function (res) {

          })
      }
    },
    personSure(){
    		  console.log(this.personSelectList)
      let self=this
      if(null!=this.personSelectList && this.personSelectList.length>0){
        let postData={
          "matchCode":this.$route.query.matchCode,
          "roomCode":this.personInfo.roomCode,
          "clubCode":this.userInfos.clubCode,
          "peopleType":1,//0-运动员 1-非运动员
          peopleList:[]
        }
        for(let i=0;i<this.personSelectList.length;i++){
          postData.peopleList.push(
            {
              "peopleCode":this.personSelectList[i].serviceCode,
              "peopleType":this.personSelectList[i].serviceType, //0-运动员 1-家长 2-教练 3-领队
              "peopleSex":this.personSelectList[i].serviceSex
            }
          )

        }
        console.log('postDatapostData',postData)
        axios.post('/marlin/sign/data/sign/hotel/add',postData)
          .then(function (res) {
            console.log(res)
            self.$message({
              message:res.data.msg,
              type:'success'
            })
            self.dialogPersonListShow=false
          })
          .catch(function (res) {

          })
      }
    },
    handleOrderInfo(index,row){
      this.dialogPersonListShow=true
      let  self=this

      this.personInfo=row
      let postData={
        roomCode:row.roomCode,
        clubCode:this.userInfos.clubCode,
        matchCode:this.$route.query.matchCode,
        peopleType:1
      }
      axios.post('/marlin/sign/data/sign/hotel/query/list',postData)
        .then(function (res) {
          console.log(1111,res,row)
          let athList=[]
          for(let j=0;j<self.personList.length;j++){
            for(let i=0;i<res.data.rst.length;i++){
              if(row.roomCode==res.data.rst[i].roomCode){
                if(res.data.rst[i].peopleCode==self.personList[j].serviceCode){
                  athList.push(self.personList[j])
                }
              }
            }
          }
          self.persontoggleSelection(athList)
        })
        .catch(function (res) {

        })
    },
    handleChange(val){
    },
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {

	        if (columnIndex === 0) {
	          if (row.roomSize>0) {
	            return {
	              rowspan: row.roomSize,
	              colspan: 1
	            };
	          } else {
	            return {
	              rowspan: 0,
	              colspan: 0
	            };
	          }
	        }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // orderSure(){
    //     var self=this
    //     var postData={
    //       matchCode:this.matchInfo[0].matchCode,
    //       clubCode:this.userInfos.clubCode,
    //       roomCode:this.orderForm.roomCode,
    //       signNumber:this.orderForm.reserveNumbers
    //     }
    //     if(self.orderForm.reserveNumbers==0){
    //       self.$message({
    //           message:'请选择预订数量！',
    //           type:'warning'
    //         })
    //     }else{
    //       axios.post('/marlin/sign/data/hotel/info/apply',postData)
    //       .then(function(res){
    //           if(res.data.code==0){
    //           self.$message({
    //             message:'预订信息保存成功！',
    //             type:'success'
    //           })
    //           self.dialogFormVisible=false
    //           self.onSubmit()
    //     }
    //       })
    //       .catch(function(res){
    //         overdue(res.response,res.response.status,self)
    //       })
    //     }
    //
	 //    }
    }
  };
</script>

<style scoped lang="less">
	.save{
		text-align: center;
		margin: 20px 0;
		button{
			width: 120px;
		}
	}
	.hotel .name-wrapper{
		display: inline-block;
		margin: 0px 15px
	}
	.cell span{
		margin-left: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/hotel.vue